import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmallError = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 134,
	height: 106,
	viewBox: "0 0 134 106",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 49.203C-1.77816e-05 57.2041 6.7093 76.3118 21.2224 84.7164C36.0412 93.298 48.4655 86.1177 65.941 86.4008C79.1403 86.6147 87.2741 90.4103 99.7452 86.4008C117.391 80.7277 136.536 71.0013 132.488 54.1159C129.674 42.3733 116.27 42.5639 107.931 33.3413C99.6122 24.1412 100.504 14.6429 90.1951 7.37302C67.8793 -8.36368 40.6634 3.42744 19.8581 20.8485C9.28656 29.7004 1.77816e-05 41.2019 0 49.203Z",
			fill: "#FFF2F5"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 69.9274,
			cy: 22.878,
			r: 14.9521,
			stroke: "#F39DB2",
			strokeWidth: .653017,
			strokeLinecap: "round",
			strokeDasharray: "2.61 3.92"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 24.9202,
			cy: 24.1534,
			rx: 24.9202,
			ry: 24.1534,
			transform: "matrix(-1 0 0 1 61.876 31.3125)",
			stroke: "#F29DB1",
			strokeWidth: .653017,
			strokeLinecap: "round",
			strokeDasharray: "2.61 3.92"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 103.857,
			cy: 59.1083,
			r: 10.1598,
			stroke: "#FFCAD7",
			strokeWidth: .653017,
			strokeLinecap: "round",
			strokeDasharray: "2.61 3.92"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 45.6418,
			y: 24.2836,
			width: 7.9909,
			height: 1.58779,
			transform: "rotate(-45 45.6418 24.2836)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 46.7021,
			y: 18.4938,
			width: 8.26385,
			height: 1.69961,
			transform: "rotate(45 46.7021 18.4938)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98.9974,
			y: 37.2404,
			width: 3.99545,
			height: .793893,
			transform: "rotate(-45 98.9974 37.2404)",
			fill: "#FCBFCE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 99.5277,
			y: 34.3455,
			width: 4.13192,
			height: .849807,
			transform: "rotate(45 99.5277 34.3455)",
			fill: "#FCBFCE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 66.7302,
			y: 82.8252,
			width: 5.32726,
			height: 1.05852,
			transform: "rotate(-45 66.7302 82.8252)",
			fill: "#FDBFCE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 67.4373,
			y: 78.9653,
			width: 5.50923,
			height: 1.13308,
			transform: "rotate(45 67.4373 78.9653)",
			fill: "#FDBFCE"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 118.982,
			y: 62.5701,
			width: 5.32726,
			height: 1.05852,
			transform: "rotate(-45 118.982 62.5701)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 119.689,
			y: 58.7102,
			width: 5.50923,
			height: 1.13308,
			transform: "rotate(45 119.689 58.7102)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.1808 20.5486C30.1262 20.5486 31.7032 22.1256 31.7032 24.071C31.7032 26.0165 30.1263 27.5935 28.1808 27.5935C26.2354 27.5934 24.6583 26.0165 24.6583 24.071C24.6584 22.1257 26.2354 20.5487 28.1808 20.5486ZM27.5284 25.4451C27.7264 25.5392 27.947 25.5935 28.1808 25.5935C29.0217 25.5935 29.7032 24.912 29.7032 24.071C29.7032 23.8376 29.6487 23.6174 29.5548 23.4197L27.5284 25.4451ZM28.1808 22.5486C27.34 22.5487 26.6584 23.2302 26.6583 24.071C26.6583 24.3275 26.7221 24.569 26.8341 24.781L28.8907 22.7244C28.6787 22.6124 28.4373 22.5486 28.1808 22.5486Z",
			fill: "#FCBFCE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.0684 72.8055C99.0846 72.9078 100.688 74.5754 100.688 76.6171L100.683 76.8134C100.58 78.8295 98.9137 80.4333 96.8721 80.4335L96.6758 80.4276C94.7244 80.3289 93.1595 78.7647 93.0605 76.8134L93.0557 76.6171C93.0557 74.5095 94.7645 72.8007 96.8721 72.8007L97.0684 72.8055ZM96.041 78.2303C96.2903 78.3591 96.5723 78.4335 96.8721 78.4335C97.8749 78.4333 98.6883 77.6199 98.6885 76.6171C98.6885 76.3173 98.6141 76.0353 98.4854 75.786L96.041 78.2303ZM96.8721 74.8007C95.869 74.8007 95.0557 75.614 95.0557 76.6171C95.0557 76.941 95.1423 77.2443 95.291 77.5077L97.7627 75.036C97.4993 74.8873 97.196 74.8007 96.8721 74.8007Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.1717 17.6567C91.0856 17.3388 91.325 17.026 91.6543 17.026H94.1636C94.4929 17.026 94.7323 17.3388 94.6462 17.6567L93.3916 22.2893C93.2582 22.7817 92.5597 22.7817 92.4263 22.2893L91.1717 17.6567Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 92.909,
			cy: 25.3922,
			r: 1.02743,
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_dddd_5433_584)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M36.9874 24.897C36.9874 23.7924 37.8829 22.897 38.9874 22.897H69.2626C69.7958 22.897 70.307 23.1099 70.6826 23.4885L73.0313 25.8566L75.5036 28.3543C75.8742 28.7288 76.0822 29.2344 76.0822 29.7613V70.7168C76.0822 71.8214 75.1867 72.7168 74.0822 72.7168H38.9874C37.8829 72.7168 36.9874 71.8214 36.9874 70.7168V24.897Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 55.2877,
			y1: 49.1779,
			x2: 68.7588,
			y2: 49.1779,
			stroke: "#FFCAD7",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 55.2877,
			y1: 46.2423,
			x2: 68.7588,
			y2: 46.2423,
			stroke: "#FFCAD7",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 55.5813,
			y1: 51.8198,
			x2: 62.5943,
			y2: 51.8198,
			stroke: "#FFCAD7",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 45.22,
			y1: 30.1841,
			x2: 53.9969,
			y2: 30.1841,
			stroke: "#EF476F",
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 44.72,
			y1: 34.49,
			x2: 68.7589,
			y2: 34.49,
			stroke: "#FFCAD7",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 44.7581,
			y1: 37.1422,
			x2: 57.8517,
			y2: 37.1422,
			stroke: "#FFCAD7",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 58.0168,
			y1: 66.7037,
			x2: 69.2589,
			y2: 66.7037,
			stroke: "#EF476F",
			strokeWidth: .5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_5433_584)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M70.096 28.7921L75.967 29.0857L69.8025 22.9211L70.096 28.7921Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.1996 55.2288C44.1153 54.9115 44.3546 54.6005 44.6829 54.6005H48.3729C48.7012 54.6005 48.9405 54.9115 48.8562 55.2288L47.0111 62.1748C46.8795 62.6704 46.1763 62.6704 46.0447 62.1748L44.1996 55.2288Z",
			fill: "#EF476F"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 46.5279,
			cy: 65.6087,
			r: 1.32098,
			fill: "#EF476F"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_dd_5433_584)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 50.2721,
				y: 69.072,
				width: 49.835,
				height: 9.90218,
				transform: "rotate(-45 50.2721 69.072)",
				fill: "#EF476F"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 56.8865,
				y: 32.9529,
				width: 51.5372,
				height: 10.5996,
				transform: "rotate(45 56.8865 32.9529)",
				fill: "#EF476F"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_dddd_5433_584",
				x: 27.4874,
				y: 21.397,
				width: 58.0947,
				height: 84.3198,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.5 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.980392 0 0 0 0 0.8 0 0 0 0 0.843137 0 0 0 0.23 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5433_584"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 6 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.980392 0 0 0 0 0.8 0 0 0 0 0.843137 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_5433_584",
						result: "effect2_dropShadow_5433_584"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 13.5 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.980392 0 0 0 0 0.8 0 0 0 0 0.843137 0 0 0 0.12 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_5433_584",
						result: "effect3_dropShadow_5433_584"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 23.5 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.75 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.980392 0 0 0 0 0.8 0 0 0 0 0.843137 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_5433_584",
						result: "effect4_dropShadow_5433_584"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect4_dropShadow_5433_584",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_5433_584",
				x: 68.3025,
				y: 22.4211,
				width: 9.16455,
				height: 9.16455,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .75 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.832587 0 0 0 0 0.851891 0 0 0 0 0.920833 0 0 0 0.5 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5433_584"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_5433_584",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_dd_5433_584",
				x: 39.3915,
				y: 32.9529,
				width: 63.9373,
				height: 63.9374,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 10 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.937255 0 0 0 0 0.278431 0 0 0 0 0.435294 0 0 0 0.19 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5433_584"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2.5 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.25 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.937255 0 0 0 0 0.278431 0 0 0 0 0.435294 0 0 0 0.29 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_5433_584",
						result: "effect2_dropShadow_5433_584"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_5433_584",
						result: "shape"
					})
				]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgSmallError);
export { ForwardRef as ReactComponent };
